import CognitoForgotPassword from './cognito-forgot-password';
export default CognitoForgotPassword;
